<template>
    <fieldset
        :id="id"
        class="lni-u-mb3"
    >
        <legend class="lni-u-heading--2 lni-u-mb2">
            {{ getData('employer.heading') }}
        </legend>
        <div
            class="lni-u-mt2 lni-u-mb3"
        >
            <div class="lni-u-mt1 lni-u-mb2 lni-u-reading-width--max">
                <lni-input-text
                    :id="`${id}_name`"
                    :filled="true"
                    :fullWidth="true"
                    :maxlength="49"
                    :required="true"
                />
            </div>
            <div class="lni-u-full-width lni-u-flex lni-u-flex-wrap">
                <lni-input-phone
                    :id="`${id}_phone-number`"
                    class="lni-u-mt1 lni-u-mr1 lni-u-mb2"
                    :filled="true"
                    :isFieldset="false"
                    :hasExtension="false"
                    :fullWidth="true"
                    :minlength="10"
                    :maxlength="49"
                    :required="true"
                />
                <lni-input-email
                    :id="`${id}_email-address`"
                    class="lni-u-mb2"
                    :filled="true"
                    :fullWidth="true"
                    :maxlength="49"
                    :required="false"
                />
            </div>
            <lni-input-address
                :id="`${id}_address`"
                class="lni-u-mb3"
                :filled="true"
                :hasInlineMessages="false"
                :countyOptions="getData('counties')"
            />
        </div>
    </fieldset>
</template>

<script>
export default {
    name: 'LniRetaliationEmployer',
    computed: {
        employer() {
            return this.$store.state.appState?.employer;
        },
    },
    methods: {
        formatUbi(ubi) {
            return ubi.replace(/(\d{3})(\d{3})(\d{3})/g, "$1 $2 $3");
        },
        getData(name) {
            return this.$store.getters['appState/data'] ? this.$store.getters['appState/data'](name) : '';
        },
        toggleAddEmployerSection(value) {
            this.$store.commit('setAttribute', {
                id: `${this.id}_add-section`,
                attribute: 'isOpen',
                value,
            }, {
                root: true,
            });
        },
    },
};
</script>